var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, Type } from '@decahedron/entity';
var MolEmploymentTemporaryAgencyWork = /** @class */ (function (_super) {
    __extends(MolEmploymentTemporaryAgencyWork, _super);
    function MolEmploymentTemporaryAgencyWork() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.companyName = null;
        _this.displayCompanyName = false;
        return _this;
    }
    return MolEmploymentTemporaryAgencyWork;
}(Entity));
export { MolEmploymentTemporaryAgencyWork };
var MolEmploymentRelationshipDetails = /** @class */ (function (_super) {
    __extends(MolEmploymentRelationshipDetails, _super);
    function MolEmploymentRelationshipDetails() {
        // amalgamation of all possible fields based on MolEmploymentRelationshipType
        // apprenticeship, isTemporaryAgencyWork exist if type is 'employment'
        // temporaryAgencyWork exists if isTemporaryAgencyWork is true
        // franchising exists if type is 'entrepreneurship'
        // if type is 'public-service', no fields exist
        // fields get removed from JSON if they are not relevant to the type
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.apprenticeship = false;
        _this.isTemporaryAgencyWork = false;
        _this.temporaryAgencyWork = new MolEmploymentTemporaryAgencyWork();
        _this.franchising = false;
        return _this;
    }
    __decorate([
        Type(MolEmploymentTemporaryAgencyWork),
        __metadata("design:type", MolEmploymentTemporaryAgencyWork)
    ], MolEmploymentRelationshipDetails.prototype, "temporaryAgencyWork", void 0);
    return MolEmploymentRelationshipDetails;
}(Entity));
export { MolEmploymentRelationshipDetails };
var MolEmploymentRelationship = /** @class */ (function (_super) {
    __extends(MolEmploymentRelationship, _super);
    function MolEmploymentRelationship() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'employment';
        _this.details = new MolEmploymentRelationshipDetails();
        return _this;
    }
    MolEmploymentRelationship.prototype.toJson = function (toSnake, asString) {
        var json = _super.prototype.toJson.call(this, toSnake, asString);
        switch (this.type) {
            case 'employment':
                if (json.details.is_temporary_agency_work !== true) {
                    delete json.details.temporary_agency_work;
                }
                delete json.details.franchising;
                break;
            case 'public_service':
                delete json.details;
                break;
            case 'entrepreneurship':
                delete json.details.apprenticeship;
                delete json.details.is_temporary_agency_work;
                delete json.details.temporary_agency_work;
                break;
        }
        return json;
    };
    __decorate([
        Type(MolEmploymentRelationshipDetails),
        __metadata("design:type", MolEmploymentRelationshipDetails)
    ], MolEmploymentRelationship.prototype, "details", void 0);
    return MolEmploymentRelationship;
}(Entity));
export { MolEmploymentRelationship };
